(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elysarne-home-reference"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elysarne-home-products')) {
    class ElysarneHomeProducts extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.elysarne-home__products');
        this.cards = Array.from(this.track?.children || []);
        this.controls = this.querySelector('.elysarne-home__product-controls');
        this.previous = this.querySelector('.elysarne-home__product-prev');
        this.next = this.querySelector('.elysarne-home__product-next');
        const dots = this.querySelector('.elysarne-home__product-dots');
        this.mobile = window.matchMedia('(max-width:749px)');
        this.index = 0;
        if (!this.track || !this.cards.length) return;
        dots.replaceChildren();
        this.dots = this.cards.map((card, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', card.querySelector('h3').textContent.trim());
          dot.setAttribute('aria-controls', card.id);
          dot.addEventListener('click', () => this.goTo(index), options);
          dots.append(dot);
          return dot;
        });
        this.controls.hidden = this.cards.length < 2;
        this.previous.addEventListener('click', () => this.goTo(this.index - 1), options);
        this.next.addEventListener('click', () => this.goTo(this.index + 1), options);
        this.track.addEventListener('scroll', () => this.sync(), { ...options, passive:true });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track || !this.mobile.matches) return;
          const target = { ArrowLeft:this.index-1, ArrowRight:this.index+1, Home:0, End:this.cards.length-1 }[event.key];
          if (target === undefined) return;
          event.preventDefault();
          this.goTo(target);
        }, options);
        this.mobile.addEventListener('change', () => this.sync(), options);
        this.resizeObserver = new ResizeObserver(() => this.sync());
        this.resizeObserver.observe(this.track);
        this.sync();
      }
      disconnectedCallback() { this.controller?.abort(); this.resizeObserver?.disconnect(); }
      offset(index) { return this.cards[index].offsetLeft - this.cards[0].offsetLeft; }
      goTo(index) {
        if (!this.mobile.matches) return;
        const target = Math.max(0, Math.min(this.cards.length-1,index));
        const reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
        this.track.scrollTo({ left:this.offset(target), behavior:reduced?'instant':'smooth' });
      }
      sync() {
        this.track.tabIndex = this.mobile.matches ? 0 : -1;
        let distance = Infinity;
        this.cards.forEach((card,index) => {
          const gap = Math.abs(this.offset(index)-this.track.scrollLeft);
          if (gap < distance) { distance=gap; this.index=index; }
        });
        this.dots.forEach((dot,index) => {
          if (index===this.index) dot.setAttribute('aria-current','true');
          else dot.removeAttribute('aria-current');
        });
        this.previous.disabled = this.index===0;
        this.next.disabled = this.index===this.cards.length-1;
      }
    }
    customElements.define('elysarne-home-products',ElysarneHomeProducts);
  }
  if (!customElements.get('elysarne-home-testimonials')) {
    class ElysarneHomeTestimonials extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.elysarne-home__reviews');
        this.cards = Array.from(this.querySelectorAll('[data-review-index]'));
        this.dots = Array.from(this.querySelectorAll('[data-review-dot]'));
        this.previousButton = this.querySelector('[data-review-prev]');
        this.nextButton = this.querySelector('[data-review-next]');
        if (!this.track || !this.cards.length) return;
        this.currentIndex = 0;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.handleScroll = () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateControls());
        };
        this.handleClick = (event) => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-review-prev')) this.goTo(this.currentIndex - 1);
          if (button.hasAttribute('data-review-next')) this.goTo(this.currentIndex + 1);
          if (button.hasAttribute('data-review-dot')) this.goTo(Number(button.dataset.reviewDot));
        };
        this.handleKey = (event) => {
          if (event.target !== this.track || !this.mobile.matches) return;
          const next = { ArrowLeft: this.currentIndex - 1, ArrowRight: this.currentIndex + 1, Home: 0, End: this.cards.length - 1 }[event.key];
          if (next === undefined) return;
          event.preventDefault();
          this.goTo(next);
        };
        this.handleBlockSelect = (event) => {
          const card = event.target.closest('[data-review-index]');
          if (card && this.contains(card)) this.goTo(Number(card.dataset.reviewIndex), true);
        };
        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKey);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.track);
        this.updateControls();
      }
      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.handleScroll);
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKey);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
      }
      cardOffset(index) {
        const padding = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        return Math.max(0, this.cards[index].offsetLeft - padding);
      }
      goTo(index, instant = false) {
        if (!this.mobile.matches) return;
        const target = Math.max(0, Math.min(this.cards.length - 1, index));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.cardOffset(target), behavior: instant || reducedMotion ? 'instant' : 'smooth' });
      }
      updateControls() {
        if (!this.mobile.matches) {
          this.track.removeAttribute('tabindex');
          return;
        }
        this.track.setAttribute('tabindex', '0');
        let nearest = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const gap = Math.abs(this.cardOffset(index) - this.track.scrollLeft);
          if (gap < distance) { distance = gap; nearest = index; }
        });
        this.currentIndex = nearest;
        this.dots.forEach((dot, index) => {
          if (index === nearest) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (this.previousButton) this.previousButton.disabled = nearest === 0;
        if (this.nextButton) this.nextButton.disabled = nearest === this.cards.length - 1;
      }
    }
    customElements.define('elysarne-home-testimonials', ElysarneHomeTestimonials);
  }
  if (!customElements.get('elysarne-home-services')) {
    class ElysarneHomeServices extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.elysarne-home__services');
        this.cards = Array.from(this.querySelectorAll('[data-service-index]'));
        this.dots = Array.from(this.querySelectorAll('[data-service-dot]'));
        this.previousButton = this.querySelector('[data-service-prev]');
        this.nextButton = this.querySelector('[data-service-next]');
        this.status = this.querySelector('[data-service-status]');
        if (!this.track || !this.cards.length) return;
        this.currentIndex = 0;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.handleScroll = () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateControls());
        };
        this.handleClick = (event) => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-service-prev')) this.goTo(this.currentIndex - 1);
          if (button.hasAttribute('data-service-next')) this.goTo(this.currentIndex + 1);
          if (button.hasAttribute('data-service-dot')) this.goTo(Number(button.dataset.serviceDot));
        };
        this.handleKey = (event) => {
          if (event.target !== this.track || !this.mobile.matches) return;
          const next = { ArrowLeft: this.currentIndex - 1, ArrowRight: this.currentIndex + 1, Home: 0, End: this.cards.length - 1 }[event.key];
          if (next === undefined) return;
          event.preventDefault();
          this.goTo(next);
        };
        this.handleBlockSelect = (event) => {
          const card = event.target.closest('[data-service-index]');
          if (card && this.contains(card)) this.goTo(Number(card.dataset.serviceIndex), true);
        };
        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKey);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.track);
        this.setAttribute('data-ready', '');
        this.updateControls();
      }
      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.handleScroll);
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKey);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
        this.removeAttribute('data-ready');
      }
      cardOffset(index) {
        return this.cards[index].offsetLeft;
      }
      goTo(index, instant = false) {
        if (!this.mobile.matches) return;
        const target = Math.max(0, Math.min(this.cards.length - 1, index));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.cardOffset(target), behavior: instant || reducedMotion ? 'instant' : 'smooth' });
      }
      updateControls() {
        if (!this.mobile.matches) {
          this.track.removeAttribute('tabindex');
          return;
        }
        this.track.setAttribute('tabindex', '0');
        let nearest = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const gap = Math.abs(this.cardOffset(index) - this.track.scrollLeft);
          if (gap < distance) { distance = gap; nearest = index; }
        });
        this.currentIndex = nearest;
        this.dots.forEach((dot, index) => {
          if (index === nearest) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (this.previousButton) this.previousButton.disabled = nearest === 0;
        if (this.nextButton) this.nextButton.disabled = nearest === this.cards.length - 1;
        if (this.status) this.status.textContent = `${nearest + 1} / ${this.cards.length}`;
      }
    }
    customElements.define('elysarne-home-services', ElysarneHomeServices);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elysarne-pdp-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elysarne-product-tabs')) {
  customElements.define('elysarne-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = [...this.querySelectorAll('[role="tabpanel"]')];
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
        panels.forEach((panel, i) => { panel.hidden = i !== index; });
        if (focus) tabs[index]?.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', (event) => {
          let target;
          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') target = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = tabs.length - 1;
          if (target !== undefined) { event.preventDefault(); select(target, true); }
        });
      });
      this.addEventListener('shopify:block:select', (event) => { const index = panels.findIndex(panel => panel.contains(event.target)); if (index >= 0) select(index); });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elysarne-ugc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elysarne-ugc')) {
    class ElysarneUgc extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        const videos = [...this.querySelectorAll('.elysarne-ugc__video')];

        videos.forEach((video) => {
          const toggle = video.parentElement.querySelector('.elysarne-ugc__toggle');
          if (!toggle) return;

          const sync = () => {
            const playing = !video.paused && !video.ended;
            toggle.toggleAttribute('data-playing', playing);
            toggle.setAttribute('aria-label', playing ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
          };

          toggle.hidden = false;
          toggle.addEventListener('click', async () => {
            if (video.paused || video.ended) {
              try {
                await video.play();
              } catch {
                video.controls = true;
                video.focus();
              }
            } else {
              video.pause();
            }
            sync();
          }, options);

          video.addEventListener('play', () => {
            document.querySelectorAll('elysarne-ugc video').forEach((other) => {
              if (other !== video) other.pause();
            });
            sync();
          }, options);
          video.addEventListener('pause', sync, options);
          video.addEventListener('ended', sync, options);
          sync();
        });
      }

      disconnectedCallback() {
        this.querySelectorAll('video').forEach((video) => video.pause());
        this.abortController?.abort();
      }
    }

    customElements.define('elysarne-ugc', ElysarneUgc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
